// extracted by mini-css-extract-plugin
export var dropdownContainer = "_qp-0";
export var leftAlign = "_qp-4";
export var listItem = "_qp-2";
export var listItemWrapper = "_qp-1";
export var operationText = "_qp-3";